/*
 * Copyright (c) 2020.
 * Simon
 */

import {toast} from "react-toastify";
import {i18n} from "../language/i18n";
import {LOGOUT_ERROR} from "../types";
import {
    TOP_RANKING_DETAIL_ERROR,
    TOP_RANKING_INDEX_ERROR
} from "../containers/SensorTower/TopRanking/Action/TopRankingActionType";
import {HOT_TREND_INDEX_ERROR} from "../containers/SensorTower/HotTrend/Action/HotTrendActionType";
import {ST_APP_INDEX_ERROR} from "../containers/SensorTower/App/Action/AppActionType";
import {ME_ST_ERROR} from "../actions/login/LoginActionType";

/**
 * @param {*} state
 * @param {*} action
 */
const ApiErrorMessageReducer = (state = {}, action) => {
    switch (action.type) {
        case ME_ST_ERROR:
        case HOT_TREND_INDEX_ERROR:
        case TOP_RANKING_INDEX_ERROR:
        case TOP_RANKING_DETAIL_ERROR:
        case ST_APP_INDEX_ERROR:
        case LOGOUT_ERROR:
            let message = action.payload.message;
            toast.error(i18n.t(message));
            return {...state, action};
        default:
            return {...state};
    }
};

export {ApiErrorMessageReducer};
